import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      user-select: none;\n      cursor: default;\n      line-height: normal;\n    "])));
  },
  removeBaselineSpacer: function removeBaselineSpacer() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      vertical-align: bottom;\n    "])));
  },
  item: function item() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      display: table;\n      margin-top: 0;\n      width: 100%;\n    "])));
  },
  itemFirst: function itemFirst() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      margin-top: 0;\n    "])));
  },
  itemInline: function itemInline() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      display: inline-table;\n      margin-right: 15px;\n      margin-top: 0;\n      width: auto;\n    "])));
  }
});